<template>
  <transition-group name="flip-list" tag="ul">
    <li class="mb-2" v-for="(item, index) in workingList" :key="'_' + item.adminname">
      <v-card style="position: relative">
        <div
          class="text-xs-center"
          style="position: absolute; top: -25px;z-index: 1; left: 0; right: 0"
        >
          <img src="/static/img/assets/aston/crowns.png" v-if="index == 0" style="width: 30px; " />
        </div>

        <v-card-text>
          <div class="text-xs-center">
            <v-avatar size="50">
              <img :src="item.image_url" />
            </v-avatar>
            <div class="headline mt-2 font-weight-bold">
              {{ item.adminname ? item.adminname : '-' }}
            </div>
            <div class="caption">จำนวนทำงาน</div>
            <h2 class="display-2 primary--text ma-1 font-weight-bold">
              {{ item.closetask | numberFormat }}
            </h2>
          </div>
        </v-card-text>
      </v-card>
    </li>
  </transition-group>
</template>

<script>
import api from '@/api'
import moment from 'moment'
export default {
  props: ['datefrom', 'dateto', 'outsource'],
  data: function() {
    return {
      workingList: [],
      refreshInterval: undefined
    }
  },
  mounted: function() {
    var vm = this
    vm.refreshInterval = setInterval(function() {
      vm.getAdmin()
    }, 15000)
  },
  methods: {
    playCheerSound: function() {
      var snd = new Audio('/static/sound/cheer.wav')
      snd.play()
    },
    getAdmin: function() {
      var vm = this
      vm.getAstonCloseTasksPerAdmin().then(function(workingList) {
        var firstPlace = null
        if (vm.workingList && vm.workingList.length > 0) {
          firstPlace = vm.workingList[0].adminname
        }

        vm.workingList = workingList

        if (workingList.length > 0) {
          if (firstPlace != null && firstPlace != workingList[0].adminname) {
            vm.playCheerSound()
          }
        }
      })
    },
    getAstonCloseTasksPerAdmin: function() {
      let vm = this
      var data = {
        datefrom: moment(vm.datefrom).format('YYYY/MM/DD'),
        dateto: moment(vm.dateto).format('YYYY/MM/DD')
      }
      let apifunc = vm.outsource
        ? 'getAstonCloseTasksPerAdminOutsource'
        : 'getAstonCloseTasksPerAdmin'
      return new Promise((resolve, reject) => {
        api[apifunc](data, function(error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          if (response.data) {
            resolve(response.data)
          }
          resolve([])
        })
      })
    }
  },
  beforeDestroy: function() {
    clearInterval(this.refreshInterval)
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/AstonAdminList.vue